import { render, staticRenderFns } from "./ModalUserCurrent.vue?vue&type=template&id=6ebd8d08&scoped=true&"
import script from "./ModalUserCurrent.vue?vue&type=script&lang=js&"
export * from "./ModalUserCurrent.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserCurrent.vue?vue&type=style&index=0&id=6ebd8d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd8d08",
  null
  
)

export default component.exports